export default __webpack_public_path__ + "static/swim-e73e014b8a600bac784756ab28ad412f.webp";